import {FileStatusObjects, TypeOfLiberalityRecordObjects} from "../../staticEntities";
import { ObjectId } from 'bson'

export const module_ = {
    object: 'FileCategory',
    tKey: 'Pièces',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    viewMap: {
        dt: [
            {path: 'code'},
            {path: 'title'},
            {path: 'necessaryOrUsefulTypesOfLiberalityRecord', tKey: 'Nature(s) dossier'},
        ],
        form: {
            fields: [
                {path: 'code', required: true},
                {path: 'title', required: true},
                {
                    path: 'fileConfigurations',
                    tKey: 'configuration',
                    type: 'accordion',
                    removable: false,
                    default: [
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[0],
                            fileStatus: FileStatusObjects.find(obj => obj.id === 'useless'),
                            categories: []
                        },
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[1],
                            fileStatus: FileStatusObjects.find(obj => obj.id === 'useless'),
                            categories: []
                        },
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[2],
                            fileStatus: FileStatusObjects.find(obj => obj.id === 'useless'),
                            categories: []
                        },
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[3],
                            fileStatus: FileStatusObjects.find(obj => obj.id === 'useless'),
                            categories: []
                        },
                    ],
                    viewMap: {
                        dt: [
                            {path: 'typeOfLiberalityRecord', tKey: 'typeOfFile'},
                            {
                                path: 'fileStatus',
                                editable: true,
                                type: 'dropdownObject'
                            },
                            {
                                path: 'categories',
                                tKey: 'categoriesAndNatures',
                                editable: true,
                                type: 'tags',
                                filters: ['isCategoryOrNature'],
                                fieldPath: ['id', 'name', 'natureOfProperty', 'category'],
                                rowFilter: (rowData, allValues) => {
                                    const typeId = rowData.typeOfLiberalityRecord?.id
                                    if (typeId === 'lifeInsurance') return []
                                    return typeId === 'legs' ? allValues.filter(v => v.category) : allValues.filter(v => v.natureOfProperty)
                                }
                            }
                        ]
                    }
                },
            ]
        }
    }
}
